import { ValueOf } from "@/types/type";

export const PURCHASE_TYPE = {
  ADD_ON_GENERATIVE_CREDITS: "ADD_ON_GENERATIVE_CREDITS",
  SUBSCRIPTION: "SUBSCRIPTION",
  API_SUBSCRIPTION: "API_SUBSCRIPTION",
} as const;

export type PurchaseType = ValueOf<typeof PURCHASE_TYPE>;
